export default __webpack_public_path__ + "assets/images/540-small.png";